@let userAccount = user();

<button
  mat-button
  id="account-button"
  matTooltipClass="multiline-tooltip"
  [matMenuTriggerFor]="accountMenu"
  [matTooltip]="userTooltip"
  matBadge="!"
  [matBadgeHidden]="!notificationService.accountSections().any"
  matBadgeColor="warn"
  matBadgeSize="small"
  style="color: white">
  @if (isImpersonating) {
    <mat-icon>vpn_key</mat-icon>
  }
  @if (!isImpersonating) {
    <mat-icon>account_circle</mat-icon>
  }
  <span class="menu-label">{{ 'Account' | translate: locale.language }}</span>
</button>
<mat-menu #accountMenu="matMenu" xPosition="before" yPosition="below">
  @if (userAccount) {
    <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
    <div
      mat-menu-item
      class="account-menu-header"
      id="loggedInUser"
      (keydown.enter)="onUserClick()"
      (click)="onUserClick()">
      <mat-icon>account_circle</mat-icon>
      <div class="account-menu-info">
        <span class="account-menu-name">{{ userDisplayName }}</span>
        @if (userEmail) {
          <span class="account-menu-email">{{ userEmail }}</span>
        }
        @if (userAccount?.agency && userAccount?.tenantId) {
          <span class="account-menu-agency">{{ userAccount.agency }}</span>
        }
      </div>
    </div>
    <mat-divider></mat-divider>
  }
  @if (
    userAccount &&
    (canImpersonate ||
      isImpersonating ||
      isChangeEnvironmentsEnabled ||
      (isSuperAdmin && !isChangeEnvironmentsEnabled) ||
      canOverrideFeaturesSupported)
  ) {
    @if (canImpersonate && !isImpersonating) {
      <button mat-menu-item id="impersonateUser" (click)="showImpersonate()">
        <mat-icon>vpn_key</mat-icon>
        <span>{{ 'ImpersonateUser' | translate: locale.language }}</span>
      </button>
    }
    @if (isImpersonating) {
      <button mat-menu-item id="stopImpersonate" (click)="stopImpersonate()">
        <mat-icon>vpn_key_off</mat-icon>
        <span>{{ 'StopImpersonate' | translate: locale.language }}</span>
      </button>
    }
    @if (isChangeEnvironmentsEnabled) {
      <button mat-menu-item id="changeApi" (click)="showChangeApi()">
        <mat-icon matBadge="{{ isChangedEnvironment ? '!' : '' }}" matBadgeColor="accent">api</mat-icon>
        <span>{{ 'ChangeApi' | translate: locale.language }}</span>
      </button>
    }
    @if (isSuperAdmin && !isChangeEnvironmentsEnabled) {
      <button mat-menu-item id="enableChangeApi" (click)="showEnableChangeEnvironments()">
        <mat-icon>api</mat-icon>
        <span>{{ 'Enable Change Environments' | translate: locale.language }}</span>
      </button>
    }
    @if (canOverrideFeaturesSupported) {
      <button mat-menu-item (click)="overrideFeatureSupported()">
        <mat-icon>api</mat-icon>
        <span>{{ 'Override Supported Features' | translate: locale.language }}</span>
      </button>
    }
    <mat-divider></mat-divider>
  }
  @if (userAccount && hasSecuritySettings) {
    <button id="securitySettings" mat-menu-item [matMenuTriggerFor]="securityMenu">
      <mat-icon
        [matBadge]="notificationService.accountSections().security ? '!' : ''"
        [matBadgeHidden]="!notificationService.accountSections().security"
        matBadgeColor="warn"
        matBadgeSize="small">
        lock
      </mat-icon>
      <span class="menu-item-content">
        <span class="menu-item-title">{{ 'Security settings' | translate: locale.language }}</span>
        <span class="menu-item-subtitle">{{ securitySubtitle | translate: locale.language }}</span>
      </span>
    </button>
    <mat-menu #securityMenu="matMenu">
      @if (canChangePassword) {
        <button id="changePassword" mat-menu-item (click)="changePassword()">
          <mat-icon>lock</mat-icon>
          <span>{{ 'Change password' | translate: locale.language }}</span>
        </button>
      }
      @if (canManageMfa) {
        <button id="setupMfa" mat-menu-item (click)="configureMfa()">
          <mat-icon
            [matBadge]="notificationService.accountSections().security ? '!' : ''"
            [matBadgeHidden]="!notificationService.accountSections().security"
            matBadgeColor="warn"
            matBadgeSize="small">
            phonelink_lock
          </mat-icon>
          <span>{{ 'Multi-Factor Authentication' | translate: locale.language }}</span>
        </button>
      }
    </mat-menu>
  }
  @if (canChangeThemeMode()) {
    <button id="themeMenu" mat-menu-item [matMenuTriggerFor]="themeSubmenu">
      <mat-icon class="with-text">
        {{ themeService.resolvedTheme() === 'light' ? 'light_mode' : 'dark_mode' }} </mat-icon
      >{{ 'Theme' | translate: locale.language }}
    </button>
    <mat-menu #themeSubmenu="matMenu" xPosition="before">
      <button id="themeLight" mat-menu-item (click)="setThemeMode('light')">
        <mat-icon class="with-text"> {{ themeService.themeMode() === 'light' ? 'check' : 'light_mode' }} </mat-icon>
        {{ 'ThemeLight' | translate: locale.language }}
      </button>
      <button id="themeDark" mat-menu-item (click)="setThemeMode('dark')">
        <mat-icon class="with-text"> {{ themeService.themeMode() === 'dark' ? 'check' : 'dark_mode' }} </mat-icon>
        {{ 'ThemeDark' | translate: locale.language }}
      </button>
      <button id="themeSystem" mat-menu-item (click)="setThemeMode('system')">
        <mat-icon class="with-text">
          {{ themeService.themeMode() === 'system' ? 'check' : 'brightness_auto' }} </mat-icon
        >{{ 'ThemeSystem' | translate: locale.language }}
      </button>
    </mat-menu>
  }
  <button id="signOut" mat-menu-item (click)="logout()">
    <mat-icon>power_settings_new</mat-icon>
    <span>{{ 'SignOut' | translate: locale.language }}</span>
  </button>
</mat-menu>
